export function setTheme(themeName) {
  const id = 'theme-style';
  // Light/dark variants are defined in the base stylesheets already loaded by index.html.
  // Keep those sheets before application CSS so shared button/input overrides retain priority.
  if (themeName === "dark" || themeName === "light") {
    document.getElementById(id)?.remove();
    return;
  }

  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  link.href = `/themes/${themeName}.css`;
}
